import { useEffect, useState } from 'react';

export function useBackgroundSize(imgurl: string): string {
  const [backgroundSizeState, setBackgroundSizeState] = useState('cover');
  useEffect(() => {
    const img = new Image();
    img.src = imgurl;
    img.onload = () => {
      if (img.naturalWidth > img.naturalHeight) {
        setBackgroundSizeState('cover');
      } else if (img.naturalWidth < img.naturalHeight) {
        setBackgroundSizeState('contain');
      }
    };
  }, [imgurl]);

  return backgroundSizeState;
}
